"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCertificate(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M23.234 2c.423 0 .766.343.766.766v18.383a.766.766 0 01-.766.766H.766A.766.766 0 010 21.149V2.766C0 2.343.343 2 .766 2zm-.766 1.532H1.532v16.851h20.936V3.532zm-6.383 10.723a.766.766 0 01.104 1.525l-.104.007h-8.17a.766.766 0 01-.104-1.525l.104-.007h8.17zm2.043-3.064a.766.766 0 01.104 1.525l-.104.007H5.872a.766.766 0 01-.104-1.525l.104-.007h12.256zm-4.085-3.063a.766.766 0 01.103 1.525l-.103.007H9.957a.766.766 0 01-.103-1.525l.103-.007h4.086z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgCertificate;
exports.default = _default;